<template>
  <div class="social" :class="{ 'auth-social-header': headerStyle }">
    <UiText
      v-if="!headerStyle"
      font="body-heading-5"
      color="typography-body01"
      :text="fastRegAuthText"
    />
    <div class="social__buttons">
      <UiBtn
        v-for="item in socialList"
        :key="item.icon"
        class="social__item"
        :class="{
          disabled: isDisable,
        }"
        color="line"
        icon-only
        type="button"
        :data-id="`register-${item.icon}-click`"
        v-bind="item.dataGtmId ? { ...$attrs, dataGtmId: item.dataGtmId } : {...$attrs}"
        :size="size"
        :icon="`socials/${item.icon}`"
        @click="socialRegAuth(item)"
      />
    </div>
  </div>
</template>

<script>
import { storageService } from '@/services'

export default {
  name: 'RegAuthSocial',
  props: {
    headerStyle: { type: Boolean, default: false },
    socialList: { type: Array, require: true },
    size: { type: [Object, String], default: 'm' },
  },
  data() {
    return {
      social: '',
      submittedSocial: '',
      isDisable: false,
    }
  },
  computed: {
    userSocial() {
      return this.$store.getters['user/GET_USER_SOCIAL'] || ''
    },
    fastRegAuthText() {
      return this.$route.query.bigModal === 'registration'
        ? this.$t('regAuthForgot.fastReg')
        : this.$t('regAuthForgot.fastAuth')
    },
  },
  beforeDestroy() {
    this.submittedSocial = ''
    this.isDisable = false
  },
  methods: {
    socialRegAuth(item) {
      this.submittedSocial = item.social
      this.isDisable = true

      // push data for GTM
      this.$store.dispatch('gtm/push', {
        vCategory: 'modal_signup',
        vAction: `signup_click_${item.social}`,
      })
      this.$store
        .dispatch('user/USER_SOCIAL', item.social)
        .then((res) => {
          // if (item.social === 'google') {
          //   this.submittedSocial = ''
          //   const params = 'scrollbars=no,resizable=no,status=no,location=no,toolbar=no,menubar=no,width=400,height=400,left=100,top=100'
          //   window.open(this.userSocial['url'], 'test', params)
          //   storageService.setItem('loginSuccessRedirect', '/')
          //   return
          // }
          // if (item.social === "facebook") {
          //   window.location.href = this.userSocial["url"];
          //   return;
          // }
          if (res) {
            this.submittedSocial = ''
            storageService.setItem('regRoute', this.$route.path)
            window.location.href = this.userSocial['url']
            this.isDisable = false
            localStorage.setItem(
              'locale',
              storageService.getItem('i18n_redirected')
            )

            return
          }

          this.isDisable = false
        })
        .catch(() => {
          this.submittedSocial = ''
          this.isDisable = false
        })
    },
  },
}
</script>

<style lang="scss" src="./style.scss"></style>
